import { updateOnEditEstimateCell } from "api/volSurfaceApi";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { revertCellValue } from "helpers/generalHelper";
import { updateVolSurfaceEstimateData } from "helpers/volSurfaceHelper";
import { useCallback } from "react";

function useUpdateEstimatesTable({ gridRef }) {
  const {
    setIsCellEditing,
    setRowEditingData,
    setVolCalcTable,
    volCalcTable,
    lockedData,
    setLockedData,
  } = useVolSurfaceControlTable();

  const onCellEditingStopped = useCallback(
    (event) => {
      +event.oldValue === +event.newValue && setIsCellEditing(false);
      +event.oldValue === +event.newValue && setIsCellEditing(false);
      if (+event.oldValue === +event.newValue) return;

      const node = event.node;
      const rowData = node.group ? node.aggData : node.data;

      const prepareBody = {
        vol_smile_id: rowData.vol_smile_id,
        new_strike: +event.newValue,
        column_key: event?.colDef?.field === "0" ? 0 : 1,
      };

      setIsCellEditing(true);
      updateOnEditEstimateCell(prepareBody)
        .then((res) => {
          const response = res?.data?.data;
          if (res.status === 423) {
            setLockedData({
              model_id: response?.model_id,
              model: response?.model,
              show_lock_modal: true,
              is_locked: true,
              locked_by: res?.data?.message,
              lock_comparison_surface_dropdown:
                lockedData?.lock_comparison_surface_dropdown,
              event: event,
            });
          } else if (res.status !== 200) {
            revertCellValue(event);
          } else {
            const updatedData = updateVolSurfaceEstimateData(
              response,
              volCalcTable
            );
            setVolCalcTable(updatedData);
            let refreshParams = { force: true };
            gridRef.current.api.refreshCells(refreshParams);
            setIsCellEditing(false);
            setRowEditingData(null);
          }
        })
        .catch((e) => {
          revertCellValue(event);
          console.log("Error while setting data");

          setIsCellEditing(false);
          setRowEditingData(null);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setIsCellEditing, setRowEditingData, setVolCalcTable, volCalcTable]
  );

  return { onCellEditingStopped };
}

export default useUpdateEstimatesTable;
